import { render, staticRenderFns } from "./ItemListMultipleSelectedListItem.vue?vue&type=template&id=38be8722"
import script from "./ItemListMultipleSelectedListItem.vue?vue&type=script&lang=js"
export * from "./ItemListMultipleSelectedListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports